import { ref } from 'vue';

/**
 * Composable to centralize the state of the notification menu.
 */

const isOpen = ref(false);

export function useNotificationState() {
    function open() {
        isOpen.value = true;
    }

    function close() {
        isOpen.value = false;
    }

    function toggle() {
        isOpen.value = !isOpen.value;
    }

    return { isOpen, open, close, toggle };
}
